import Payment from "./payment/Payment";
import { Util } from "../shared/services";
import Result from "./payment-result/Result";
import {HCROUTES} from "../shared/constants/Constant";

const paymentRoutes = [
    {
        path: '/thanh-toan',
        name: HCROUTES.payment,
        component: Payment,
        meta: {
            title: 'Thanh toán'
        },
        beforeEnter: Util.authenticatedRoute
    },
    {
        path: `/ket-qua-thanh-toan/:order_id`,
        name: HCROUTES.payment_result,
        component: Result,
        meta: {
            title: 'Kết quả thanh toán'
        },
        beforeEnter: Util.authenticatedRoute
    }
];

export default paymentRoutes;
